<template>
  <div class="agreement_box">
    <div class="agreement_centent">
      <div class="agreement_box_title">{{ $t("agreement.tgaagreement") }}</div>
      <div class="agreement_text">{{ $t("agreement.agreementtext") }}</div>
      <div class="check_box CU" @click="selectcheck">
        <div class="nocheck" v-if="!check"></div>
        <img class="check" v-else src="@/img/check.png" alt="" />
        <div class="checktext">{{ $t("agreement.agreeagreement") }}</div>
      </div>
      <div class="next CU" @click="next">{{ $t("agreement.next") }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      check: false,
    };
  },
  computed: {
    ...mapState("user", ["Info"]),
  },
  methods: {
    ...mapActions("user", ["tipMessage", "updateUserInfoExt"]),
    selectcheck() {
      this.check = !this.check;
    },
    // 点击跳转
    async next() {
      if (!this.check) {
        this.tipMessage({
          context: this.$t("agreement.nonext"),
        });
        return;
      }
      var obj = localStorage.getItem("obj");
      let res = await this.updateUserInfoExt({
        $axios: this.$axios,
        key: "baseInfo",
        value: JSON.parse(obj),
      });
      if (res.code == 200) {
        if (
          localStorage.getItem("roleName") &&
          localStorage.getItem("roleName").includes("GAME_DEVELOPER")
        ) {
          this.$router.push({
            path: "/game_management",
          });
        } else {
          this.$router.push({
            path: "/app_management",
          });
        }
      } else {
        this.tipMessage({
          context: this.$t("agreement.error"),
        });
      }
    },
  },
};
</script>

<style scoped="scoped">
.agreement_box {
  width: 100%;
  height: 100%;
}
.agreement_centent {
  margin: 90px auto 0;
  width: 1160px;
  height: 580px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding-top: 65px;
}
.agreement_box_title {
  margin-bottom: 51px;
  color: #282828;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}
.agreement_text {
  height: 170px;
  overflow: auto;
  padding: 0 82px;
}
.check_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nocheck {
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: solid 1px #282828;
}
.check {
  width: 14px;
  height: 14px;
}
.checktext {
  margin-left: 9px;
}

.next {
  margin: 32px auto 0;
  width: 325px;
  height: 50px;
  background-color: #4990fa;
  border-radius: 4px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/agreement.vue